<template>
  <div class="home-container">
    <app-navbar
      @close-about="closeAbout"
      @open-about="openAbout"
      :showAbout="showAbout"
    ></app-navbar>
    <main-playing @close-about="closeAbout" :showAbout="showAbout" @open-signup="openSignup"></main-playing>
    <app-footer
      @close-about="closeAbout"
      @open-about="openAbout"
      :showAbout="showAbout"
    ></app-footer>
  </div>
</template>

<script>
import MainPlaying from "../components/main-playing";

export default {
  name: "Playing",
  components: {
    MainPlaying,
  },
  metaInfo: {
    title: "Nuance Radio",
    meta: [
      {
        property: "og:title",
        content: "Nuance Radio",
      },
    ],
  },
  data() {
    return {
      showAbout: false,
    };
  },
  methods: {
    openAbout() {
      this.showAbout = true;
    },
    closeAbout() {
      this.showAbout = false;
    },
    openSignup() {
      this.$emit('open-signup');
    },
  },
};
</script>

<style scoped>
.home-container {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
</style>
